/**
 * Returns subscription flags for the given channel.
 * @param params
 */
export function useSubscriptionFlags(channel) {
    return channel?.config?.subscription_flags ?? {};
}
